export const InputLabelProps = {
    style: {
        zIndex: 0
    },
};
